import React from "react";
import { WeatheredStripUser } from "@weatheredstrip/shared";

const AuthUserContext = React.createContext<WeatheredStripUser | null>(null);

export default AuthUserContext;
